<template>
  <div>
    <el-row>
      <el-col :span="12">
        <el-tree
          :data="data"
          show-checkbox
          node-key="id"
          default-expand-all
          :expand-on-click-node="false"
        >
          <span slot-scope="{ node, data }" class="custom-tree-node">
            <span>{{ node.label }}</span>
            <span>{{ node.pathUrl }}</span>
            <span>
              <!-- <el-button type="text" size="mini" @click="() => edit(data)">
                编辑
              </el-button> -->

              <el-button type="text" size="mini" @click="() => append(data)">
                添加
              </el-button>
              <el-button
                type="text"
                size="mini"
                @click="() => remove(node, data)"
              >
                删除
              </el-button>
            </span>
          </span>
        </el-tree>
      </el-col>
      <el-col :span="12">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="名称">
            <el-input v-model="form.name" />
          </el-form-item>
          <el-form-item label="路由">
            <el-input v-model="form.pathUrl" />
          </el-form-item>
          <el-form-item label="排序">
            <el-input v-model="form.sort" />
          </el-form-item>
          <el-form-item label="上级id">
            <el-input v-model="form.parentId" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="addMenu">确认添加</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { post } from '@/utils/request'
export default {
  data() {
    const data = []
    return {
      data: JSON.parse(JSON.stringify(data)),
      form: {
        name: '',
        pathUrl: '',
        sort: '',
        parentId: ''
      },
      query: {
        pageNum: 1,
        pageSize: 50
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.data = []
      post('/admin/menu/getAllMenu').then((res) => {
        // console.log(res.data);
        res.data.data.map((item) => {
          const obj = {}
          obj.children = []
          obj.id = item.id
          obj.label = item.name
          obj.pathUrl = item.pathUrl
          // const children = item.children;
          item.children.map((item1) => {
            const obj1 = {}
            obj1.id = item1.id
            obj1.label = item1.name
            obj1.pathUrl = item1.pathUrl
            obj.children.push(obj1)
          })
          this.data.push(obj)
        })
      })
    },
    append(data) {
      console.log(data)
      this.form.parentId = data.id
    },
    edit(data) {
      console.log(data)
      this.form.name = data.label
      this.form.parentId = data.id
      this.form.pathUrl = data.pathUrl
    },
    addMenu() {
      post('/admin/menu/add', this.form).then((res) => {
        const dataInformation = res.data
        console.log(dataInformation)
        if (dataInformation.code == 20000) {
          this.getData()
        }
      })
    },

    remove(node, data) {
      console.log(data)
      const id = data.id
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          post('/admin/menu/delete', { id }).then((res) => {
            this.getData()
          })
        })
    },

    renderContent(h, { node, data, store }) {
      return (
        <span class='custom-tree-node'>
          <span>{node.label}</span>
          <span>
            <el-button
              size='mini'
              type='text'
              on-click={() => this.append(data)}
            >
              Append
            </el-button>
            <el-button
              size='mini'
              type='text'
              on-click={() => this.remove(node, data)}
            >
              Delete
            </el-button>
          </span>
        </span>
      )
    }
  }
}
</script>

<style scoped lang="scss">
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
</style>
